import { apiRequest } from "../client";
import type { CompanyColorPreferences } from "./types";

const ANI_COMPANY_ID = "ani";

/** Build color-preferences URL; tenants rely on auth scoping (no company_id param). */
export function buildColorPreferencesUrl(companyId?: string): string {
  const params = new URLSearchParams();
  if (companyId?.toLowerCase() === ANI_COMPANY_ID) {
    params.append("company_id", companyId);
  }
  const query = params.toString();
  return query
    ? `/company/color-preferences?${query}`
    : "/company/color-preferences";
}

export async function getColorPreferences(
  companyId?: string
): Promise<CompanyColorPreferences> {
  return apiRequest<CompanyColorPreferences>({
    method: "GET",
    url: buildColorPreferencesUrl(companyId),
  });
}

export async function getPlaygroundPreferences() {
  return apiRequest({
    method: "GET",
    url: `/company/playground-preferences`,
  });
}

export async function getChartColors(companyId?: string) {
  const params = new URLSearchParams();
  if (companyId) {
    params.append("company_id", companyId);
  }

  return apiRequest({
    method: "GET",
    url: `/company/chart-colors?${params}`,
  });
}

export async function getColorPalette(companyId?: string) {
  const params = new URLSearchParams();
  if (companyId) {
    params.append("company_id", companyId);
  }

  return apiRequest({
    method: "GET",
    url: `/company/palette?${params}`,
  });
}
